import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from '@/lib/auth-context-def';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth 必须在 AuthProvider 内部使用');
  }
  return ctx;
}
